export const PERMISSIONS = {
  ADMIN: {
    CREATE: 'ADMIN.CREATE',
    READ: 'ADMIN.READ',
    UPDATE: 'ADMIN.UPDATE',
    DELETE: 'ADMIN.DELETE',
  },
  ADVANCED_PASSWORD: {
    READ: 'ADVANCED_PASSWORD.READ',
    UPDATE: 'ADVANCED_PASSWORD.UPDATE',
  },
  BASIC_PASSWORD: {
    READ: 'BASIC_PASSWORD.READ',
    UPDATE: 'BASIC_PASSWORD.UPDATE',
  },
  NAVIGATION: {},
  USER: {
    CREATE: 'USER.CREATE',
    READ: 'USER.READ',
    UPDATE: 'USER.UPDATE',
    DELETE: 'USER.DELETE',
  },
};

export default PERMISSIONS;
